import { pickBy } from 'lodash';
import { Channel } from 'redux-saga';
import ISocketHandler from '../../../../api/sockets/ISocketHandler';
import ISocketMessage from '../../../../api/sockets/ISocketMessage';
import checkUndefinedableValue from '../../../../utils/checkUndefinedableValue';
import { serializeTask, serializeTaskLog } from '../../../serializers/tasks';
import {
  WS_UPDATE_ACTIVE_TASK,
  WS_ADD_TASK_LOG_IN_LIST,
} from '../../../actions/tasks';

class ActiveTaskChannelHandler implements ISocketHandler {
  socketChannel: Channel<Record<string, unknown>>;

  constructor(channel: Channel<Record<string, unknown>>) {
    this.socketChannel = channel;
  }

  update(message: ISocketMessage): void {
    const task = serializeTask(message.data);
    const updatedTaskFields = pickBy(task, checkUndefinedableValue);

    this.socketChannel.put({
      type: WS_UPDATE_ACTIVE_TASK,
      payload: { activeTask: updatedTaskFields },
    });
  }

  create(message: ISocketMessage): void {
    // тут пока может придти только новый лог задачи, больше ничего
    const log = serializeTaskLog(message.data.task_log);

    this.socketChannel.put({
      type: WS_ADD_TASK_LOG_IN_LIST,
      payload: { log },
    });
  }

  delete(): void {
    return undefined;
  }

  info(): void {
    return undefined;
  }
}

export default ActiveTaskChannelHandler;
